// styled components
import { Container } from 'theme/elements'
import * as Elements from './elements'

export function Footer() {

  return <Elements.Wrapper>
    <Container>
      <Elements.InnerContainer>
        <Elements.CopyrightText>
          © 2026 Global construction LLC
        </Elements.CopyrightText>
      </Elements.InnerContainer>
    </Container>
  </Elements.Wrapper>
}